// @ts-nocheck
import { Plugin } from '/root/workspace/storagesystem_5dn7/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request','qiankun',],
});

export { plugin };
